// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,import_extension=js"
// @generated from file vitesse/ai/v1/live.proto (package vitesse.ai.v1, syntax proto3)
/* eslint-disable */
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
/**
 * Describes the file vitesse/ai/v1/live.proto.
 */
export const file_vitesse_ai_v1_live = /*@__PURE__*/ fileDesc("Chh2aXRlc3NlL2FpL3YxL2xpdmUucHJvdG8SDXZpdGVzc2UuYWkudjEiTQoOU3Vic2NyaWJlU2NvcGUSKAoGdG9waWNzGAEgAygOMhgudml0ZXNzZS5haS52MS5MaXZlVG9waWMSEQoJc2luY2Vfc2VxGAIgASgEIrEBCglSb29tRnJhbWUSCwoDc2VxGAEgASgEEisKBGtpbmQYAiABKA4yHS52aXRlc3NlLmFpLnYxLlJvb21GcmFtZS5LaW5kEicKBXRvcGljGAMgASgOMhgudml0ZXNzZS5haS52MS5MaXZlVG9waWMiQQoES2luZBIUChBLSU5EX1VOU1BFQ0lGSUVEEAASDgoKS0lORF9IRUxMTxABEhMKD0tJTkRfSU5WQUxJREFURRACKp8BCglMaXZlVG9waWMSGgoWTElWRV9UT1BJQ19VTlNQRUNJRklFRBAAEhQKEExJVkVfVE9QSUNfVVNBR0UQARIVChFMSVZFX1RPUElDX0NPTkZJRxACEhoKFkxJVkVfVE9QSUNfVFJBTlNDUklQVFMQAxIVChFMSVZFX1RPUElDX0FVRElUUxAEEhYKEkxJVkVfVE9QSUNfU1RPUkFHRRAFQrwBChFjb20udml0ZXNzZS5haS52MUIJTGl2ZVByb3RvUAFaRmdpdGh1Yi5jb20vTW92ZW5kaS1haS92aXRlc3NlLXBsYXRmb3JtL3Byb3RvL2dlbi9nby92aXRlc3NlL2FpL3YxO2FpdjGiAgNWQViqAg1WaXRlc3NlLkFpLlYxygINVml0ZXNzZVxBaVxWMeICGVZpdGVzc2VcQWlcVjFcR1BCTWV0YWRhdGHqAg9WaXRlc3NlOjpBaTo6VjFiBnByb3RvMw");
/**
 * Describes the message vitesse.ai.v1.SubscribeScope.
 * Use `create(SubscribeScopeSchema)` to create a new message.
 */
export const SubscribeScopeSchema = /*@__PURE__*/ messageDesc(file_vitesse_ai_v1_live, 0);
/**
 * Describes the message vitesse.ai.v1.RoomFrame.
 * Use `create(RoomFrameSchema)` to create a new message.
 */
export const RoomFrameSchema = /*@__PURE__*/ messageDesc(file_vitesse_ai_v1_live, 1);
/**
 * @generated from enum vitesse.ai.v1.RoomFrame.Kind
 */
export var RoomFrame_Kind;
(function (RoomFrame_Kind) {
    /**
     * @generated from enum value: KIND_UNSPECIFIED = 0;
     */
    RoomFrame_Kind[RoomFrame_Kind["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * first frame after (re)subscribe — carries the current seq, no topic payload
     *
     * @generated from enum value: KIND_HELLO = 1;
     */
    RoomFrame_Kind[RoomFrame_Kind["HELLO"] = 1] = "HELLO";
    /**
     * `topic` advanced → re-fetch its unary snapshot
     *
     * @generated from enum value: KIND_INVALIDATE = 2;
     */
    RoomFrame_Kind[RoomFrame_Kind["INVALIDATE"] = 2] = "INVALIDATE";
})(RoomFrame_Kind || (RoomFrame_Kind = {}));
/**
 * Describes the enum vitesse.ai.v1.RoomFrame.Kind.
 */
export const RoomFrame_KindSchema = /*@__PURE__*/ enumDesc(file_vitesse_ai_v1_live, 1, 0);
/**
 * The live surfaces a viewer can scope to — viewport-driven (only what's on screen). A single open
 * transcript is its own per-conversation room, not a console topic.
 *
 * @generated from enum vitesse.ai.v1.LiveTopic
 */
export var LiveTopic;
(function (LiveTopic) {
    /**
     * @generated from enum value: LIVE_TOPIC_UNSPECIFIED = 0;
     */
    LiveTopic[LiveTopic["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * the usage/analytics dashboard
     *
     * @generated from enum value: LIVE_TOPIC_USAGE = 1;
     */
    LiveTopic[LiveTopic["USAGE"] = 1] = "USAGE";
    /**
     * the config surface (multi-admin live-sync)
     *
     * @generated from enum value: LIVE_TOPIC_CONFIG = 2;
     */
    LiveTopic[LiveTopic["CONFIG"] = 2] = "CONFIG";
    /**
     * the conversation LIST (not a single transcript)
     *
     * @generated from enum value: LIVE_TOPIC_TRANSCRIPTS = 3;
     */
    LiveTopic[LiveTopic["TRANSCRIPTS"] = 3] = "TRANSCRIPTS";
    /**
     * the agent trail — a run started, advanced, or ended
     *
     * @generated from enum value: LIVE_TOPIC_AUDITS = 4;
     */
    LiveTopic[LiveTopic["AUDITS"] = 4] = "AUDITS";
    /**
     *
     * Stored bytes changed — a file uploaded, a conversation deleted, a sweep run.
     *
     * The billing panel reads a number that other people move: a colleague uploading a file changes
     * what this org is billed, and a panel that loaded once shows a figure that was true when the
     * dialog opened. Polling it would be the other way to notice, and the frontend does not poll.
     *
     * @generated from enum value: LIVE_TOPIC_STORAGE = 5;
     */
    LiveTopic[LiveTopic["STORAGE"] = 5] = "STORAGE";
})(LiveTopic || (LiveTopic = {}));
/**
 * Describes the enum vitesse.ai.v1.LiveTopic.
 */
export const LiveTopicSchema = /*@__PURE__*/ enumDesc(file_vitesse_ai_v1_live, 0);
//# sourceMappingURL=live_pb.js.map